import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import i18next from 'i18next';
import * as storage from '../../utils/storage'
import { IsEnglish } from '../../utils/language';
import styles from '../../styles/schedule.module.css';

const useStyles = makeStyles((theme) => ({
    firstCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "160px"
        },
        textAlign: 'left',
        float: 'left'
    },
    secondCell: {
        width: '350px',
        '@media (max-width: 600px)': {
            width: "65px"
        },
        float: 'left'
    }
}));

const StyledFirstTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 14,
        width: '25%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "25px"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 14,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

const StyledSecondTableCell = withStyles((theme) => ({
    head: {
        color: '#000000!important',
        fontSize: 14,
        width: '75%',
        '@media (max-width: 600px)': {
            fontSize: 12,
            width: "75%"
        },
        fontWeight: 'bold'
    },
    body: {
        fontSize: 14,
        '@media (max-width: 600px)': {
            fontSize: 11,
        }
    },
}))(TableCell);

export default function ScheduleLegend(props) {
    const classes = useStyles();
    const [data, setData] = React.useState([]);

    useEffect(() => {
        loadLegend();
    }, []);

    const loadLegend = () => {
        const colors = storage.getColorCalendar();

        let listColor = [];
        for (const obj in colors) {
            if (colors[obj] != null) {
                const objLegend = getDescriptionColor(obj);
                listColor.push({ key: colors[obj], value: objLegend.description, order: objLegend.order });
            }
        }

        setData(
            listColor.sort((a, b) => {
                if (a.order < b.order) {
                    return -1
                }
            })
        );
    }

    const getDescriptionColor = (color) => {
        switch (color) {
            case "vacation":
                return { description: i18next.t('schedule:color.vacation'), order: 0 };
            case "absence":
                return { description: i18next.t('schedule:color.absence'), order: 10 };
            case "planning":
                return { description: i18next.t('schedule:color.planification'), order: 20 };
            case "meal":
                return { description: i18next.t('schedule:color.meal'), order: 30 };
           case "holiday":
                return { description: i18next.t('schedule:color.holiday'), order: 40 };
            case "partialAbsence":
                return { description: i18next.t('schedule:color.partialAbsence'), order: 50 };
            case "off":
                return { description: i18next.t('schedule:color.offDay'), order: 60 };
            case "slotWithoutTime":
                return { description: i18next.t('schedule:color.noAllocatedSchedule'), order: 70 };
            case "filledAbsence":
                return { description: i18next.t('schedule:color.allocatedSchedule'), order: 80 };
            case "replacement":
                return { description: i18next.t('schedule:color.replacement'), order: 90 };
            case "dayShift":
                return { description: i18next.t('schedule:color.dayShift'), order: 100 };
            case "eveningShift":
                return { description: i18next.t('schedule:color.eveningShift'), order: 110 };
            case "nightShift":
                return { description: i18next.t('schedule:color.nightShift'), order: 120 };
        }
    }

    return (
        <div id="divRootLegend">
            <TableContainer>
                <Table className={classes.table} aria-label="spanning table">
                    <TableHead>
                        <TableRow>
                            <StyledFirstTableCell>{i18next.t('schedule:color.color')}</StyledFirstTableCell>
                            <StyledSecondTableCell>{i18next.t('schedule:color.description')}</StyledSecondTableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {data != null && data.map((obj, index) =>
                            <TableRow key={index}>
                                <StyledFirstTableCell><div style={{ backgroundColor: obj.key }}>&nbsp;</div></StyledFirstTableCell>
                                <StyledSecondTableCell>{obj.value}</StyledSecondTableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}